import { AnonymousIdentityProvider } from "../identity/AnonymousIdentityProvider";
import type { IdentityProvider } from "../identity/IdentityProvider";
import { SessionUploader } from "./sessionUploader";

export const identityProvider: IdentityProvider = new AnonymousIdentityProvider();
export const sessionUploader = new SessionUploader();
